module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Error")]), _vm._v(" "), _c('mt-noti-banner', {
    attrs: {
      "type": "error",
      "title": "Notification title",
      "subTitle": "Subtitle",
      "actionLabel": "Action"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('mt-noti-banner', {
    attrs: {
      "title": "Notification title",
      "subTitle": "Subtitle",
      "actionLabel": "Action"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Success")]), _vm._v(" "), _c('mt-noti-banner', {
    attrs: {
      "type": "success",
      "title": "Notification title",
      "subTitle": "Subtitle",
      "actionLabel": "Action"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Information")]), _vm._v(" "), _c('mt-noti-banner', {
    attrs: {
      "type": "info",
      "title": "Notification title",
      "subTitle": "Subtitle",
      "actionLabel": "Action"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "styles"
  }, [_c('h2', [_vm._v("Style")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20 colors"
  }, [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Error")]), _vm._v(" "), _c('mt-noti-banner', {
    attrs: {
      "type": "error",
      "title": "Notification title",
      "subTitle": "Subtitle",
      "actionLabel": "Action"
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('mt-noti-banner', {
    attrs: {
      "title": "Notification title",
      "subTitle": "Subtitle",
      "actionLabel": "Action"
    }
  })], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Success")]), _vm._v(" "), _c('mt-noti-banner', {
    attrs: {
      "type": "success",
      "title": "Notification title",
      "subTitle": "Subtitle",
      "actionLabel": "Action"
    }
  })], 1), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left height250 mt--bg--neutrals-light-gray-01"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Infomation")]), _vm._v(" "), _c('mt-noti-banner', {
    attrs: {
      "type": "info",
      "title": "Notification title",
      "subTitle": "Subtitle",
      "actionLabel": "Action"
    }
  })], 1), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20 sizing"
  }, [_vm._v("Sizing")]), _vm._v(" "), _c('div', {
    staticClass: "left imgbox mt--bg--neutrals-light-gray-01"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizing
    }
  })]), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left imgbox mt--bg--neutrals-light-gray-01"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizingButton
    }
  })]), _vm._v(" "), _vm._m(5, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Background: #FEF2F0")]), _vm._v(" "), _c('p', [_vm._v("Button background: #FDD9D7")]), _vm._v(" "), _c('p', [_vm._v("Border: #F44336")]), _vm._v(" "), _c('p', [_vm._v("icon: #F44336,   #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Background: #FFFAED")]), _vm._v(" "), _c('p', [_vm._v("Button background: #FFF3CD")]), _vm._v(" "), _c('p', [_vm._v("Border: #FFC107")]), _vm._v(" "), _c('p', [_vm._v("icon: #FFC107,   #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Background: #EDFAF3")]), _vm._v(" "), _c('p', [_vm._v("Button background: #CCF4DC")]), _vm._v(" "), _c('p', [_vm._v("Border: #00C853")]), _vm._v(" "), _c('p', [_vm._v("icon: #00C853,   #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Background: #F5F4FF")]), _vm._v(" "), _c('p', [_vm._v("Button background: #E3E0FF")]), _vm._v(" "), _c('p', [_vm._v("Border: #7364FF")]), _vm._v(" "), _c('p', [_vm._v("icon: #7364FF,   #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Width: auto")]), _vm._v(" "), _c('p', [_vm._v("Height: 42px")]), _vm._v(" "), _c('p', [_vm._v("border: 1px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 14px")]), _vm._v(" "), _c('p', [_vm._v("Line height: 22px")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Button heigth: 26px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 14px ")]), _vm._v(" "), _c('p', [_vm._v("Line height: 22px")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63917682","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationBanner.vue
// module id = XMG+
// module chunks = 0